import { defineStore } from 'pinia';
export const useMapStyleStore = defineStore('mapStyle', () => {
  // 默认样式
  const defaultStyle = {
    width: '100%',
    height: '100%'
  };
  // 应用样式
  const mapContainerStyle = ref({
    ...defaultStyle
  });
  function updateStyle(newStyle) {
    mapContainerStyle.value = {
      ...defaultStyle,
      ...newStyle
    };
  }
  function resetStyle() {
    mapContainerStyle.value = {
      ...defaultStyle
    };
  }
  // Toolbar 默认样式
  const defaultToolbarStyle = {};
  // Toolbar 应用样式
  const toolBarStyle = ref({
    ...defaultToolbarStyle
  });
  function updateToolBarStyle(newStyle) {
    toolBarStyle.value = {
      ...defaultToolbarStyle,
      ...newStyle
    };
  }
  function resetToolBarStyle() {
    toolBarStyle.value = {
      ...defaultToolbarStyle
    };
  }
  return {
    mapContainerStyle,
    updateStyle,
    resetStyle,
    toolBarStyle,
    updateToolBarStyle,
    resetToolBarStyle
  };
});